<template>
    <div class='all'>
        <back></back>
        <div class="tit">
            <img :src="pic_url" alt="" id='one'>
            <div class="right">
                <div class='tem'>
                    <img :src="art_url" alt="" id='two'>
                    <span>{{art_name}}</span>
                </div>
                <p v-show='tags.length'>Tags：
                    <span v-for='item in tags' :key='item.id' style='color:rgb(114, 151, 190)'>{{item}}&nbsp;</span>
                </p>
                <p class='des'>{{description}}</p>
            </div>
        </div>
        <div class="song">
            <el-tabs v-model="activeName" stretch>
                <el-tab-pane label="歌曲列表" name="first">
                    <el-table :data="songs" :key='songs.id' fit stripe style="width: 100%" class='temp' @cell-click='toSong'>
                        <el-table-column prop="name" label="歌曲" align='center'>
                        </el-table-column>
                        <el-table-column prop="ar[0].name" label="歌手" align='center'>
                        </el-table-column>
                        <el-table-column prop="al.name" label="专辑" align='center'>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="评论" name="second">
                    <div class="hot_com">
                        <h3 style='margin:20px' v-if='hotcomment.length!=0'>热门评论</h3>
                        <comment v-for='item in hotcomment' :key='item.commentId' :name='item.user.nickname' :text='item.content' :url='item.user.avatarUrl' :timestr='item.timeStr' :bereplied='item.beReplied'></comment>
                    </div>
                    <div class="new_com">
                        <h3 style='margin:20px' v-if='newcomment.length!=0'>最新评论</h3>
                        <comment v-for='item in newcomment' :key='item.commentId' :name='item.user.nickname' :text='item.content' :url='item.user.avatarUrl' :timestr='item.timeStr' :bereplied='item.beReplied'></comment>
                    </div>
                    <!-- 分页器 -->
                    <div class='page'>
                        <el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :total="total" :current-page="page" :page-size="10" hide-on-single-page>
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import comment from '../components/comment.vue'
export default {
    name: 'album',
    components: { comment },
    data() {
        return {
            pic_url: '',
            art_url: '',
            art_name: '',
            tags: [],
            description: '',
            activeName: 'first',
            songs: [],
            hotcomment: [],
            newcomment: [],
            page: 1,
            total: 0,
            commentId: 0
        }
    },
    created() {
        this.songs = this.$route.params.songs
        this.pic_url = this.$route.params.list.picUrl
        this.art_url = this.$route.params.list.artist.picUrl
        this.art_name = this.$route.params.list.artist.name
        this.tags = this.$route.params.list.tags
        this.description = this.$route.params.list.description
        this.total = this.$route.params.list.info.commentCount
        this.commentId = this.$route.params.list.info.resourceId
        this.$api.getAlbumComment(this.$route.params.list.info.resourceId).then(res => {
            this.hotcomment = res.hotComments
            this.newcomment = res.comments
        })
        this.$parent.keep_arr.push('album')
    },
    methods: {
        handleCurrentChange(val) {
            this.page = val
            this.$api.getAlbumComment(this.commentId, (this.page - 1) * 10).then(res => {
                this.newcomment = res.comments
            })
        },
        toSong(row) {
            this.$api.toSong(row.id).then(res => {
                if (res.data[0].code === 404) {
                    this.$message({
                        message: '歌曲暂时无法播放',
                        type: 'warning',
                        center: true
                    })
                } else {
                    this.$parent.$refs.audio_ref.src = res.data[0].url
                    this.setId(row.id)
                }
            })
        },
    }
}
</script>
<style scoped>
.all {
    padding-bottom: 54px;
}

.tit {
    display: flex;
    width: 100%;
    height: 180px;
    font-size: 12px;
    background-color: rgb(250, 250, 250);
    border-bottom: 2px solid #EEEEEE
}

#one {
    width: 120px;
    height: 120px;
    margin: auto 20px;
}

#two {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 10px;
}

.right {
    flex: 1;
}

.tem {
    display: flex;
    margin: 25px 0 15px 20px;
    align-items: center;
}

.temp:hover {
    background-color: #ECECEC;
    cursor: pointer;
}

p {
    margin: 0 8px 8px 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    /* 显示三行，后面省略 */
    overflow: auto;
}

.page {
    width: 100%;
    margin: 10px auto;
    display: flex;
    justify-content: center;
}

/deep/ .active {
    border-bottom: 0;
}
</style>